import { PaperProps, styled } from "@mui/material";

import { useActiveSelection } from "hooks/selectionHooks";
import { useMapPoint } from "hooks/mapHooks";

import { LayerProperties } from "types";

import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { LayerPropertiesForMarker } from "./LayerPropertiesForMarker";

interface Props extends PaperProps {
  config: string;
  layerProperties: LayerProperties[];
}

export function LayerPointInfosForm(props: Props) {
  const { config, layerProperties, ...paperProps } = props;
  const { data: selection } = useActiveSelection(config, layerProperties);
  const [point] = useMapPoint();

  return render();

  function render() {
    if (!selection) return null;
    if (!point) return null;

    const sortedSelection = {
      ...selection,
      indicators: selection.indicators.sort((a, b) => a.order - b.order),
    };

    return (
      <Styles variant="defaultBackground" {...paperProps}>
        {sortedSelection.indicators.map((indicatorSelection) => {
          return (
            <LayerPropertiesForMarker
              key={indicatorSelection.indicatorId}
              layerProperties={layerProperties}
              config={config}
              selection={indicatorSelection}
              point={point}
            />
          );
        })}
      </Styles>
    );
  }
}

const Styles = styled(PaddedPaper)`
  flex-grow: 1;

  .form-field {
    & > .placeholder-label {
      min-height: ${({ theme }) => theme.spacing(7)};
      border: 1px solid rgba(255, 255, 255, 0.23);
    }
    & + .form-field {
      margin-top: ${({ theme }) => theme.spacing(2)};
    }

    &:last-child {
      margin-bottom: ${({ theme }) => theme.spacing(2)};
    }
  }
`;
